import React, { useState } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

import InputField from 'components/LoginForm/Input';

const RegisterTypeSelect = (props) => {
  const [checked, set_checked] = useState('agent');

  const handleChange = (value) => {
    set_checked(value);

    const event = {
      target: {
        name: 'registration_code',
        value,
      },
    };

    props.change(event);
  };

  return (
    <div className="Register__type">
      <b className="step">STEP 1: Carefully choose your category</b>

      <label htmlFor="agent" style={{ borderColor: props.individualShowData ? props.individualShowData.primary_color : '', color: props.individualShowData ? props.individualShowData.primary_color : '' }}>
        <input
          onClick={() => handleChange('agent')}
          id="agent"
          type="radio"
          name="registration_code"
          value="agent"
          required
          checked={checked === 'agent'}
        />
        <span>Travel Advisor / Agency</span>
      </label>

      <label htmlFor="industry_visitor" style={{ borderColor: props.individualShowData ? props.individualShowData.primary_color : '', color: props.individualShowData ? props.individualShowData.primary_color : '' }}>
        <input
          onClick={e => handleChange('industry_visitor')}
          id="industry_visitor"
          type="radio"
          name="registration_code"
          value="industry_visitor"
          required
          checked={checked === 'industry_visitor'}
        />
        <span>Industry Visitor / Supplier</span>
      </label>
    </div>
  );
};

export default RegisterTypeSelect;

RegisterTypeSelect.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
  default: PropTypes.string,
};

RegisterTypeSelect.defaultProps = {
  defaultVal: '',
  default: 'true',
};
